import { lazy, Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';

import ExternalLayout from 'src/layouts/external';
import SentryErrorPage from 'src/pages/SentryErrorPage';
import AuthModernCompactLayout from 'src/layouts/auth/modern-compact';
import ReferenceLandingPage from 'src/pages/external/references/reference-landing-page';

import { SplashScreen } from 'src/components/loading-screen';

const ExperienceVerificationPage = lazy(
  () => import('src/pages/external/experience-verification-page')
);

const JobBoardPage = lazy(
  () => import('src/pages/external/job-boards/job-board-page')
);

const EventLandingPage = lazy(
  () => import('src/pages/external/bookable-event/event-landing-page')
);

export const externalRoutes = [
  {
    path: 'experience-verification/:request_id',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <AuthModernCompactLayout>
            <ExperienceVerificationPage />
          </AuthModernCompactLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'job-boards/:board_id/jobs',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <JobBoardPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'reference-manager/:reference_request_id/submit-reference',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <ReferenceLandingPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/event-scheduler/events/:bookable_event_type_id',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <EventLandingPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
];
